import { useField, ErrorMessage } from "formik";

interface Props {
    name: string;
    type: string;
    placeholder?: string;
    [x: string]: any
}

export const CustomHiddenInput = (props: Props) => {
    const [field] = useField(props)

    return (
        <>
            <input type="hidden" {...field} {...props} />
            <ErrorMessage name={props.name} component="span" className="error" />
        </>
    )
}